import { observable, computed, action } from 'mobx';
import * as moment from 'moment';
import { User } from 'stores/User';

export class Utilities {
  constructor(private user: User) {}

  // Dates
  @observable public now = moment();
  @computed public get currentYear(): number {
    return this.now.year();
  }

  // Web sockets connectivity
  @observable public connectionsCount: number = 0;
  @observable public isConnectedToBackEnd: boolean = false;

  // Show offline area
  @computed public get showOfflineArea(): boolean {
    return (
      !this.isConnectedToBackEnd &&
      this.connectionsCount <= 0 &&
      this.user.isLoggedIn
    );
  }

  // Change web socket connection status
  @action public changeConnectionStatus = (connected?: boolean) => {
    connected =
      typeof connected !== 'undefined' ? connected : !this.isConnectedToBackEnd;

    if (connected) {
      this.isConnectedToBackEnd = true;
      this.connectionsCount++;
    } else {
      this.isConnectedToBackEnd = false;
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Utilities.ts